export const MONTHS = ["12", "24", "36", "48", "60"];
export const YEARS = [1, 2, 3, 4, 5];
export const EXPAND_OLD_CLUSTER_WARNING = "Expand old cluster workflow is only supported for heterogeneous cluster. To size clusters using AF, ROBO or Cloud Nodes please create a new cluster.";
export const NODE_COUNT_TABLE_MSG = "See the Node Count table";

export const COHESITY = 'Cohesity';
export const IBM = 'IBM';

// Enum for metadata fault tolerance values
export enum METADATA_FT_FACTOR {
  FT1 = 1,
  FT2 = 2,
}
export const INCR_DATA_REDUCTION_THRESHOLD = 100
export const FULL_DATA_REDUCTION_THRESHOLD = 500